import { TRANSACTION_DIRECTIONS } from '@/models/TransactionV2'
import { ACCOUNT_ASSET_TYPES } from '@/models/AccountV2'

export default (value, direction, assetType) => {
  if (SIGN_TYPES[direction] == null) {
    return value
  }

  if (assetType != null && SIGN_TYPES[direction][assetType] != null) {
    return `${SIGN_TYPES[direction][assetType]}${value}`
  }

  return `${SIGN_TYPES[direction][ACCOUNT_ASSET_TYPES.PASSIVE]}${value}`
}

const SIGN_TYPES = {
  [TRANSACTION_DIRECTIONS.INCOMING]: {
    [ACCOUNT_ASSET_TYPES.ACTIVE]: '\u2212',
    [ACCOUNT_ASSET_TYPES.PASSIVE]: '+'
  },
  [TRANSACTION_DIRECTIONS.OUTGOING]: {
    [ACCOUNT_ASSET_TYPES.ACTIVE]: '+',
    [ACCOUNT_ASSET_TYPES.PASSIVE]: '\u2212'
  }
}
